// import Axios from 'axios'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import HeaderMarket from '../../molecules/header-market/header-market'
import MarketContent from '../../molecules/market-content/market-content'
import './market.scss'

const Market = props => {
    var resultQuery = useStaticQuery(
        graphql`
                query MARKET_CONSULTING_INTERNAL{
                    allContentfulNolHomeTercerNivel(filter: {slug: {in: ["tiendas","tiendas/"]}}) {
                        nodes {
                        node_locale
                        promocionesDeProductos {
                            imagen {
                                file {
                                    url
                                }
                                description
                                }
                                descripcion {
                                json
                                }
                                ciudades {
                                nombre
                                }
                            }
                        
                            comercios {
                                titulo
                                imagen {
                                    description
                                    file {
                                        url
                                    }
                                }
                                redireccion
                                ciudades {
                                    nombre
                                }
                            }
                            titulo
                            subtituloGeneral {
                                subtituloGeneral
                            }
                        }
                    }
                }
        `
    );
    
    // const [promocion, setPromocion] = React.useState(resultQuery.allContentfulNolHomeTercerNivel.nodes[0].promocionesDeProductos)
    // const [comercio, setComercio] = React.useState(resultQuery.allContentfulNolHomeTercerNivel.nodes[0].comercios)
    const [promocion]= React.useState(resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].promocionesDeProductos)
    const [comercio] = React.useState(resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].comercios)

    React.useEffect(() => {
        // Actualiza el título del documento usando la API del navegador
        // navigator.geolocation.getCurrentPosition(pos => {
        //     var cityAux;
        //     Axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + pos.coords.latitude + "," + pos.coords.longitude + "&key=AIzaSyCN8ZrJwdNr5hJ4FkpgwMR6qzH1KS4TWlg").then(resp => {
        //         var results = resp.data.results;
        //         for (var j = 0; j < results.length; j++) {
        //             if (results[j].types[0] === 'locality') {
        //                 break;
        //             }
        //         }
        //         for (var i = 0; i < results[j].address_components.length; i++) {
        //             if (results[j].address_components[i].types[0] === "locality") {
        //                 //this is the object you are looking for City
        //                 cityAux = results[j].address_components[i];
        //             }
        //             // if (results[j].address_components[i].types[0] === "country") {
        //             //     //this is the object you are looking for
        //             //     countryAux = results[j].address_components[i];
        //             // }
        //         }
        //         setPromocion(promocion.filter((info) =>
        //             info.ciudades.find(({ nombre }) => nombre.toLowerCase() === cityAux.long_name.toLowerCase())
        //         ))
        //         setComercio(comercio.filter((info) =>
        //             info.ciudades.find(({ nombre }) => nombre.toLowerCase() === cityAux.long_name.toLowerCase())
        //         ))

        //         //city data
        //         // alert(city.long_name + " || " + country.short_name)

        //     })
        // }, () => console.log("error"))
    }, []);

    return (
        <div>
            <HeaderMarket title={props.params.titulo} />
            <MarketContent mobile={props.mobile} comercio={comercio} promocion={promocion} subtituloGeneral={resultQuery.allContentfulNolHomeTercerNivel.nodes[0].subtituloGeneral.subtituloGeneral}/>
        </div>
    )
}

export default Market
